
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { PricingTier } from "./pricing/PricingTier";
import { PRICING_TIERS } from "./pricing/pricingTierData";
import { useSubscriptionUpdate, type SubscriptionTier } from "./pricing/useSubscriptionUpdate";
import { useEffect } from "react";

interface PricingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  currentTier: SubscriptionTier;
}

export const PricingDialog = ({ open, onOpenChange, currentTier }: PricingDialogProps) => {
  const { handleUpgrade, isUpdating, resetUpdateState } = useSubscriptionUpdate(currentTier, onOpenChange);

  useEffect(() => {
    if (open) {
      resetUpdateState();
    }
  }, [open, resetUpdateState]);

  return (
    <Dialog open={open} onOpenChange={(newOpen) => {
      if (isUpdating) return;
      onOpenChange(newOpen);
    }}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center mb-4">
            Choose Your Perfect Plan
          </DialogTitle>
          <DialogDescription className="text-center text-muted-foreground">
            Select the plan that best fits your needs. You can upgrade or downgrade at any time.
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {PRICING_TIERS.map((tierData) => (
            <PricingTier
              key={tierData.tier}
              {...tierData}
              currentTier={currentTier}
              isUpdating={isUpdating}
              onUpgrade={handleUpgrade}
            />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
